.root {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}

.toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--tuna-spacing-2);
}

.chips {
  flex: 1 1 auto;
}

.summary {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1_5);
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-fontSize-sm);
  color: var(--tuna-palette-text-secondary);
}

.clear {
  padding: 0;
  border: 0;
  background: none;
  color: var(--tuna-palette-primary-main);
  font: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}

.clear:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
  border-radius: var(--tuna-shape-radius-sm);
}

/* Phones: sort first, then the chips scrolling sideways in the remaining space */
@media (max-width: 599.95px) {
  .toolbar {
    flex-direction: row-reverse;
    align-items: center;
  }

  .chips {
    min-width: 0;
  }
}
